import { IAssetBase, IAssetModel } from "@/apps/app.content";
import { Camera, Engine, HemisphericLight, Mesh, MeshBuilder, Scene, TransformNode, Vector3, StandardMaterial, ShadowGenerator, DirectionalLight, Color3 } from "babylonjs";
import { ILincolnCenterConfig } from "../../content.lincolncenter.config";
import ContentLincolnCenterScene from "../../content.lincolncenter.scene";
import { paths } from "./content.lincolncenter.miles.assets";
import { ContentMilesModel } from "./content.lincolncenter.miles.model";
import ContentLincolnCenterBuilding from "../../content.lincolncenter.building";
import { ShadowOnlyMaterial } from "babylonjs-materials";
import { ContentLincolnCenterState, ContentLincolnCenterStates } from "../../content.lincolncenter.states";
import ContentLincolnCenterBase from "../../content.lincolncenter.base";

export default class ContentLincolnCenterMiles extends ContentLincolnCenterScene {

  private _config: ILincolnCenterConfig;
  private shadowGenerator: ShadowGenerator | undefined;

  constructor(config: ILincolnCenterConfig) {
    super();
    this._config = config;
    console.log("ContentLincolnCenterMiles", this._config);
    this.contentOcclusion.config = this._config.configContentLincolnCenter;
  }

  public override init(
    engine: Engine,
    scene: Scene,
    camera: Camera,
    rootNode?: TransformNode
  ): void {
    super.init(engine, scene, camera, rootNode);
    
    if (this.isSim3D)
      this.addContent("building", new ContentLincolnCenterBuilding(this._config.configContentLincolnCenter), true);
  }

  public override start(): void {
    const hemisphericLight = new HemisphericLight("light1", new Vector3(0, 1, 0), this.scene!);
    const light = new DirectionalLight("dirLight", new Vector3(-5, -10, -5), undefined);
    // light.shadowEnabled = true;
    // light.position = new Vector3(5, 5, 0);
    
    
    // const shadowGenerator = new ShadowGenerator(1024, light);
    // this.shadowGenerator = shadowGenerator;
    // shadowGenerator.useBlurExponentialShadowMap = true; // Optional for smooth shadows
    // shadowGenerator.transparencyShadow = true;

    // shadow strength

    // create a ground plane
    const ground = MeshBuilder.CreateGround("ground", { width: 100, height: 100 }, this.scene);
    const groundMaterial = new ShadowOnlyMaterial("ground", this.scene);
    ground.material = groundMaterial;
    ground.receiveShadows = true;

  }

  public override loadAssetComplete(assetLoaded: IAssetBase): void {
    super.loadAssetComplete(assetLoaded);
    if (assetLoaded.id === "building_mesh") {
          const assetModel = assetLoaded as IAssetModel;
          
          if (assetModel.meshes) {
            assetModel.meshes.forEach((mesh) => {
              mesh.receiveShadows = true;
            });
          }
        }
  }

  public override get assets(): IAssetBase[] {
    console.log(this.contentList);
    return [
      ...this.contentList.flatMap((content) => content.assets),
    ]
  }

  public toggleContentVisibility(id: string, isVisible: boolean): void {
    console.log("toggleContentVisibility", id, isVisible);
  }

  protected override startState(newState: number): void {
      console.log("Starting state", newState);
      if (newState === ContentLincolnCenterStates.CALIBRATION) {
        this.hideAll();
        if (this._config.configContentLincolnCenter.showCalibrationVisuals)
          this.beginCalibrationVisuals();
      }
      else if (newState === ContentLincolnCenterStates.NONE) {
        this.hideAll();
      }
      else if (newState === ContentLincolnCenterStates.CONTENT) {
        this.showAll();
      }
    }
  
  
    // To toggle off the previous state
    protected override stopState(oldState: ContentLincolnCenterState) {
      console.log("Stopping state", oldState);
  
      if (oldState === ContentLincolnCenterStates.CALIBRATION) {
        if (this._config.configContentLincolnCenter.showCalibrationVisuals)
          this.endCalibrationVisuals();
      }
    }

    showAll() {
      if (this.getContent("miles") === undefined) {
        const content = new ContentMilesModel({ id: "miles", modelPath: paths.get("miles")!, config: this._config.configContentLincolnCenter.items[0] });
        this.addContent("miles", content, true);

        // get query string
        const urlParams = new URLSearchParams(window.location.search);
        const buildingDebug = urlParams.get("building");

        if (buildingDebug === "true") {
          this.addContent("building", new ContentLincolnCenterBuilding(this._config.configContentLincolnCenter), true);
        }
      }
      else {
        (this.getContent("miles") as ContentMilesModel).show();
      }
      console.log(this.contentOcclusion);
      this.contentOcclusion?.show();
    }

    hideAll() {
      if (this.getContent("miles") !== undefined) {
        (this.getContent("miles") as ContentMilesModel).hide();
      }
      this.contentOcclusion?.hide();
    }
  
    
}
